<template>
    <div class="details">
        <md-table v-if="tableData" table-header-color="primary">
            <md-table-row>
                <md-table-head>Domain</md-table-head>
                <md-table-head>Hours (forecast)</md-table-head>
                <md-table-head>Hours (estimated)</md-table-head>
                <md-table-head>Hours (actual)</md-table-head>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Research</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.Vooronderzoek) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.Vooronderzoek) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.Vooronderzoek) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Copywriting</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.Webteksten) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.Webteksten) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.Webteksten) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Wireframes</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.Wireframes) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.Wireframes) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.Wireframes) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Design</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.Design) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.Design) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.Design) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Frontend</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.Frontend) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.Frontend) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.Frontend) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Backend</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.Backend) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.Backend) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.Backend) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Staging</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.Staging) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.Staging) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.Staging) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>PM</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.PM) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.PM) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.PM) }}</md-table-cell>
            </md-table-row>
            <md-table-row>
                <md-table-cell>Empty domain</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.empty) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.empty) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.empty) }}</md-table-cell>
            </md-table-row>
            <md-table-row class="table-total">
                <md-table-cell>Total</md-table-cell>
                <md-table-cell>{{ toHours(tableData.forecast.total) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.estimated.total) }}</md-table-cell>
                <md-table-cell>{{ toHours(tableData.actual.total) }}</md-table-cell>
            </md-table-row>
        </md-table>
    </div>
</template>

<script>
import utils from "@/utils";

export default {
    name: "ProjectDetails",
    mixins: [utils],
    props: {
        tableData: Object
    }
};
</script>
